module.exports = __webpack_public_path__ + "img/fixing-bugs.ac71a4a1.svg";